import React, { useState, useContext, useEffect } from 'react';
import { VenueProfileContext } from '../../context';
import { GuestRooms } from '@weddingspot/ws-core-components';
import {
    HotelFormConnected,
    ResponsiveModalContainer,
    VenueData,
    FeatureFlagContext,
    FLAG_ROOM_BLOCK_RECOMMENDATIONS_SHOWN_ON_PROFILE,
} from '@weddingspot/ws-core-components';
import { AnalyticsEvent, logEvent } from '@weddingspot/ws-analytics';

const GuestRoomsSection = (props: { wsVenueAddress?: string; city?: string; state?: string; zipCode?: string }) => {
    const { flagEnabled } = React.useContext(FeatureFlagContext);
    const showRoomBlockRecommendations = flagEnabled(FLAG_ROOM_BLOCK_RECOMMENDATIONS_SHOWN_ON_PROFILE);

    const { csnVenueProfile, wsVenueProfile, guestRoomsSearchRes, guestRoomsProfileRes, exploreHotelsURL,  } = useContext(VenueProfileContext);
    const [showRfpModal, setShowRfpModal] = useState<boolean>(false);
    const [isRfpSent, setRfpSent] = useState<boolean>(false);

    const venueData: VenueData = { id: csnVenueProfile?.basicProfile.id };

    return (
        <>
            {!wsVenueProfile.hide_guest_rooms && (
                <GuestRooms
                    csnVenueData={csnVenueProfile}
                    onClick={() => setShowRfpModal(true)}
                    isProfileV3={true}
                    exploreHotelsUrl={exploreHotelsURL}
                    hotelsList={guestRoomsSearchRes}
                    hotelsProfiles={guestRoomsProfileRes}
                    showRecommendations={showRoomBlockRecommendations}
                />
            )}
            <ResponsiveModalContainer
                show={showRfpModal}
                headerContent={!isRfpSent ? 'Request a Proposal' : 'Success'}
                handleClickModalBackground={() => setShowRfpModal(false)}
                handleClickModalClose={() => setShowRfpModal(false)}
                className='is-RFP-container'
            >
                {!isRfpSent ? (
                    <HotelFormConnected
                        type='venueProfile'
                        onClose={() => setShowRfpModal(false)}
                        handleRoomCountSubmit={(params) => {
                            logEvent(AnalyticsEvent.EVTNM_SUBMITTED_ROOM_COUNT, params);
                            setRfpSent(true);
                        }}
                        handleClickedSpecifyGuestRooms={() => {
                            logEvent(AnalyticsEvent.EVTNM_CLICKED_SPECIFY_GUEST_ROOMS, { Source: 'Venue Profile V3' });
                        }}
                        csnVenueData={[venueData]}
                        leadSource='profile page'
                        onSuccess={() => setRfpSent(true)}
                    />
                ) : (
                    <div style={{ textAlign: 'center' }}>
                        Your request is sent! Cvent will send updates to the email address you provided.
                        <div className='InquiryWidget--success--actions'>
                            <button
                                className='InquiryWidget--success--cta nx-button nx-button--primary'
                                onClick={() => setShowRfpModal(false)}
                            >
                                Done
                            </button>
                        </div>
                    </div>
                )}
            </ResponsiveModalContainer>
        </>
    );
};

export default GuestRoomsSection;
